var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5461 15.8535C16.6262 16.7706 15.2998 18.7302 15.2998 20.9998C15.2998 24.1478 17.8518 26.6998 20.9998 26.6998C23.2694 26.6998 25.2291 25.3734 26.1461 23.4535",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0652 9.33457C23.7921 8.89101 22.4241 8.6499 20.9999 8.6499C14.1792 8.6499 8.6499 14.1792 8.6499 20.9999C8.6499 27.8206 14.1792 33.3499 20.9999 33.3499C27.8206 33.3499 33.3499 27.8206 33.3499 20.9999C33.3499 19.5757 33.1088 18.2077 32.6652 16.9346",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0891 4.31092C27.3892 2.83743 24.2924 2 21 2C10.5066 2 2 10.5066 2 21C2 31.4934 10.5066 40 21 40C31.4934 40 40 31.4934 40 21C40 17.7076 39.1626 14.6108 37.6891 11.9109",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 2L21 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpact);
export default __webpack_public_path__ + "static/media/Impact.935d1e37f314c8e10aa938b78e22b5c1.svg";
export { ForwardRef as ReactComponent };